import { HTTPClient } from "@/common/HTTPClient";

export interface MemberGetRequestParams {
  search?: string;
  role?: string;
  page?: number;
  limit?: number;
}

export interface GlobalMemberGetRequestParams {
  search?: string;
  company_ids?: number[];
  role?: string;
  status?: string;
  page?: number;
  size?: number;
}

export interface GlobalMemberInviteRequestParams {
  email: string;
  role: string;
  company_ids: number[];
}

export interface GlobalMemberUpdateRequestParams {
  name?: string;
  profileImageUrl?: string;
  email?: string;
  role?: string;
  status?: string;
  company_ids?: number[];
}

export interface MemberInviteRequestParams {
  email: string;
  role: string;
}

export interface MemberUpdateProfileRequestParams {
  name: string;
  profileImageUrl?: string;
}

export interface MemberUpdateRequestParams {
  id: number;
  role: string;
}

export class MemberClient {
  constructor(private httpClient: HTTPClient) {}

  public async getMyProfile(): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/users/me",
      method: "GET",
    });

    return data;
  }

  // TODO: Temporary fix to get members from 50 to 100 rows
  public async getMembers(company_id: number): Promise<any> {
    const params = {
      company_id,
      page: 1,
      size: 100,
    };
    const { data } = await this.httpClient.request({
      url: `/api/v1/companies/${company_id}/members`,
      method: "GET",
      params,
    });

    return data;
  }

  // TODO: Temporary fix to get members from 50 to 100 rows
  public async getMembersOnly(company_id: number): Promise<any> {
    const params = {
      company_id,
      page: 1,
      size: 100,
    };
    const { data } = await this.httpClient.request({
      url: `/api/v1/companies/${company_id}/members-only`,
      method: "GET",
      params,
    });

    return data;
  }

  // TODO: Temporary fix to get members from 50 to 100 rows
  public async getMemberMembers(equipment_tag_id: number): Promise<any> {
    const params = {
      equipment_tag_id,
      page: 1,
      size: 100,
    };
    const { data } = await this.httpClient.request({
      url: `/api/v1/equipment_model_member`,
      method: "GET",
      params,
    });

    return data;
  }

  public async createMemberInvite(company_id: number, params: MemberInviteRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/companies/${company_id}/members/invite`,
      method: "POST",
      data: params,
    });

    return data;
  }

  public async checkMemberEmail(email: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/check-email`,
      method: "GET",
      params: { email },
    });
    return data;
  }

  public async postMemberInviteResend(email: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/reinvite`,
      method: "POST",
      data: { email },
    });

    return data;
  }

  public async updateMember(params: any): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/profile`,
      method: "PUT",
      data: params,
    });

    return data;
  }
  public async memberSwitchRole(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/memberswitch-role?user_id=${id}`,
      method: "PUT",
    });

    return data;
  }

  public async updateUserProfile(params: any): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/member/profile",
      method: "PUT",
      data: params,
    });

    return data;
  }

  public async postMemberActive(email: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/active`,
      method: "POST",
      data: { email },
    });

    return data;
  }

  public async uploadProfileImage(form: FormData): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/upload/profiles`,
      method: "POST",
      data: form,
      headers: { "Content-Type": "multipart/form-data" },
    });

    return data;
  }

  public async deleteMember(email: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/inactive`,
      method: "DELETE",
      data: { email },
    });

    return data;
  }
  public async updateMemberProfile(params: any): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/member/profile-edit`,
      method: "PUT",
      data: params,
    });

    return data;
  }

  public async getAllMembers(params: GlobalMemberGetRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/members`,
      method: "GET",
      params,
    });

    return data;
  }

  public async globalInviteMember(params: GlobalMemberInviteRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/members/invite`,
      method: "POST",
      data: params,
    });

    return data;
  }

  public async globalUpdateMember(memberId: number, params: GlobalMemberUpdateRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/members/${memberId}`,
      method: "PUT",
      data: params,
    });

    return data;
  }

  public async getCompanyMembers(
    company_id: number,
    params?: { search?: string; role?: string; status?: string; page?: number; size?: number }
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/companies/${company_id}/members`,
      method: "GET",
      params: { page: 1, size: 10, ...params },
    });
    return data;
  }

  public async removeMemberFromCompany(companyId: number, memberId: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/api/v1/companies/${companyId}/members/${memberId}`,
      method: "DELETE",
    });
    return data;
  }
}
